import { Stack, StackProps } from "@mui/material";
import AlertCard, { AlertCardProps } from "./common/AlertCard";
import TitleCard, { TitleCardProps } from "./common/TitleCard";

export interface ActionItemsCardProps {
    items: AlertCardProps[];
}

function ActionItemsCard(props: ActionItemsCardProps) {
    const titleCardProps: TitleCardProps = {
        title: "Action items",
        description: "There are one or more actions that may require your attention:",
        stackProps: {
            sx: {
                gap: 2.5,
            },
        },
    };

    const stackProps: StackProps = {
        sx: {
            gap: "10px",
        },
    };

    return (
        <TitleCard {...titleCardProps}>
            <Stack {...stackProps}>
                {props.items.map((item, index) => (
                    <AlertCard key={index} {...item} />
                ))}
            </Stack>
        </TitleCard>
    );
}

export default ActionItemsCard;
